export const NavigationKey = {
  General: "general",
  Rights: "rights",
  Salary: "settingssalary",
  WorkingHours: "workingHours",
  OtherSettings: "otherSettings",
};
